import { useState, useEffect } from "react"

export default function StickyPriceBar() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero section (approximately 100vh)
      const heroHeight = window.innerHeight
      setIsVisible(window.scrollY > heroHeight)
    }

    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <div
      className={`
        fixed top-0 left-0 right-0 z-[100]
        bg-[rgba(13,13,13,0.95)] backdrop-blur-md
        border-b border-pink/20
        px-6 py-3
        transition-transform duration-300 ease-out
        ${isVisible ? 'translate-y-0' : '-translate-y-full'}
      `}
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between">
        <span className="text-white text-sm md:text-base font-medium">
          Viral Plan: <span className="text-pink font-bold">$1,900/month</span>
        </span>
        <a
          href="https://discord.gg/sy5k53rkz4"
          className="bg-pink text-white text-sm font-semibold px-4 py-2 rounded-lg
            transition-all duration-200 hover:bg-pink/90 hover:scale-105"
        >
          Get Started
        </a>
      </div>
    </div>
  )
}
